import { useEffect, useRef } from 'react';
import {
  DependencyList,
  EffectCallback,
  UseEffectReturn,
} from './type.effect.js';

/**
 * React effect hook that invokes only on update.
 * It doesn't invoke on mount
 */
export const useUpdateEffect = (
  effect: EffectCallback,
  deps: DependencyList
): UseEffectReturn => {
  const mounted = useRef(false);
  useEffect(() => {
    if (mounted.current) {
      return effect();
    }
    mounted.current = true;
  }, deps);
};
